import React from 'react'

function SitesView() {
    return (
        <div>
            <h1>SitesView</h1>
        </div>
    )
}

export default SitesView
